export const WALK_IN_COUNTER = 90;
export const STORAGE_KEYS = {
  SELECTED_SERVICE: 'SELECTED_SERVICE',
  // COMPANY_ID: 'COMPANY_ID',
  PHONE_NUMBER: 'PHONE_NUMBER', // phone number of client associate to SP
  USER_ID: 'USER_ID',
  USER_NAME: 'USER_NAME',
  USER_PHONE: 'USER_PHONE',
  FCM_TOKEN: 'FCM_TOKEN',
  COMPANY_NAME: 'COMPANY_NAME',
};
